import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import { Action, Panel } from '@studiometa/ui';
import Cart from './molecules/Cart/index.js';
import Toast from './atoms/Toast/index.js';
import 'liquid-ajax-cart';
import ProductInfo from './organisms/ProductInfo.js';
import SearchForm from './molecules/SearchForm.js';
import PanelDescriptionButton from './molecules/PanelDescriptionButton.js';
import Swiper from './molecules/Swiper/index.js';
import Header from './organisms/Header.js';
import StickyBar from './atoms/StickyBar.js';
import Facets from './organisms/Facets.js';
import Search from './organisms/Search/index.js';
import ProductShopLook from './organisms/ProductShopLook.js';
/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      Header,
      Action,
      Toast,
      Cart,
      ProductInfo,
      SearchForm,
      StickyBar,
      Swiper,
      ProductShopLook,
      Search,
      Facets,
      LogoFooter: (app) =>
        importWhenVisible(() => import('./atoms/LogoFooter.js'), 'LogoFooter', app),
      Revendeurs: (app) =>
        importWhenVisible(() => import('./organisms/Revendeurs.js'), 'Revendeurs', app),
      Stories: (app) =>
        importWhenVisible(() => import('./organisms/Stories/index.js'), 'Stories', app),
      Tooltips: (app) =>
        importWhenVisible(() => import('./organisms/Tooltips/index.js'), 'Tooltips', app),
      ProductRecommendations: (app) =>
        importWhenVisible(
          () => import('./organisms/ProductRecommendations.js'),
          'ProductRecommendations',
          app,
        ),
      Video: (app) => importWhenVisible(() => import('./atoms/Video.js'), 'Video', app),
      Accordion: (app) =>
        importWhenVisible(() => import('./molecules/Accordion/index.js'), 'Accordion', app),
      PanelDescription: Panel,
      PanelDescriptionButton,
    },
  };

  /**
   * Toaster
   * @returns {Toast}
   */
  get Toaster() {
    if (this.$children.Toast.length <= 0) {
      throw new Error('No Toast component found');
    }

    return this.$children.Toast[0];
  }

  /**
   * PanelDescription
   * @returns {PanelDescription}
   */
  get PanelDescription() {
    return this.$children.PanelDescription[0];
  }
}

export default createApp(App, document.body);
